export default {

    toFormatedDate(date){
        return moment(date).isValid() ? moment(date).format('DD/MM/YYYY'): 'N/A';
    }

}